{
  "remove": "Eliminar"
}
